module.exports = __webpack_public_path__ + "img/live-bg1.e0ba6040.png";